var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWarning = function SvgWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    className: "warning_svg__svg-icon",
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m32 3.995 28.005 51.34H3.995zm-3.5 31.506V23.835h7V35.5zm0 11.667v-7h7v7z",
    clipRule: "evenodd"
  })));
};
export { SvgWarning as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNjQgNjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTMyIDMuOTk1NDhMNjAuMDA0NyA1NS4zMzQxSDMuOTk1NDhMMzIgMy45OTU0OFpNMjguNSAzNS41MDFWMjMuODM0NUgzNS41VjM1LjUwMUgyOC41Wk0yOC41IDQ3LjE2NzlWNDAuMTY3OUgzNS41VjQ3LjE2NzlIMjguNVoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPjwvc3ZnPg==";